import { createUseStyles } from 'react-jss';

export const useGlobalStyles = createUseStyles({
  '@global': {
    'body.theme-transitioning, body.theme-transitioning *': {
      transition:
        'background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease, fill 0.3s ease, stroke 0.3s ease, width 0.3s ease, height 0.3s ease, padding 0.3s ease, margin 0.3s ease, font-size 0.3s ease, border-width 0.3s ease !important',
    },
  },
});
